import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle, LogIn, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  children: ReactNode;
  compact?: boolean;
}

interface State {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  private voltarAoLogin = () => {
    for (let index = localStorage.length - 1; index >= 0; index -= 1) {
      const key = localStorage.key(index);
      if (key?.startsWith("br-tintas-gestao-ti-auth")) localStorage.removeItem(key);
    }
    window.location.replace("/login?nova_sessao=1");
  };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Erro de renderização recuperado:", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className={this.props.compact ? "rounded-xl border bg-card p-6" : "grid min-h-screen place-items-center bg-background p-6"}>
        <div className="mx-auto max-w-lg text-center">
          <span className="mx-auto grid size-12 place-items-center rounded-full bg-destructive/10 text-destructive"><AlertTriangle /></span>
          <h1 className="mt-4 text-xl font-semibold">Não foi possível exibir esta área</h1>
          <p className="mt-2 text-sm text-muted-foreground">Atualize a página para tentar novamente. Se o problema continuar, volte à tela de acesso para renovar sua sessão.</p>
          <div className="mt-5 flex flex-wrap justify-center gap-2">
            <Button variant="outline" onClick={() => window.location.reload()}><RotateCcw className="size-4" />Atualizar página</Button>
            <Button onClick={this.voltarAoLogin}><LogIn className="size-4" />Encerrar sessão e voltar ao login</Button>
          </div>
        </div>
      </main>
    );
  }
}
